export const EMAIL_TEMPLATE_SUMMARY_FIELDS = `
  id
  name
  description
  type
  subtype
  classification
  isActive
  locales
  updatedAt
`;

export const EMAIL_TEMPLATE_FIELDS = `
  id
  type
  subtype
  classification
  name
  description
  isActive
  createdAt
  updatedAt
  contents {
    id
    locale
    subject
    designJson
    html
    editorMode
  }
`;

export const EMAIL_BRAND_THEME_FIELDS = `
  id
  type
  logoUrl
  primaryColor
  secondaryColor
  accentColor
  backgroundColor
  textColor
  fontFamily
  buttonRadius
  websiteUrl
  supportEmail
  instagramUrl
  facebookUrl
  tiktokUrl
  youtubeUrl
  xUrl
  footerTextEs
  footerTextEn
  updatedAt
`;

export const TRAVEL_AIRLINE_FIELDS = `
  id
  iataCode
  name
  checkInUrl
  logoUrl
  isActive
  updatedAt
`;
